import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ExtensionDetector.module.css';

const ExtensionDetector = () => {
  const { t } = useTranslation();
  const [isExtensionInstalled, setIsExtensionInstalled] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  const EXTENSION_ID = 'iealfioknccembacfpjgodhoehdmggak';
  const CHROME_STORE_URL = `https://chromewebstore.google.com/detail/flowdino-gestion-multi-pl/${EXTENSION_ID}`;

  useEffect(() => {
    let timeoutId;
    
    const checkExtension = () => {
      console.log('[ExtensionDetector] Début de la vérification');
      
      // Timeout de sécurité pour toujours finir la vérification
      timeoutId = setTimeout(() => {
        console.log('[ExtensionDetector] Timeout - extension non détectée');
        setIsChecking(false);
        setIsExtensionInstalled(false);
      }, 1500);

      // Méthode 1: Vérifier via un message à l'extension
      if (typeof chrome !== 'undefined' && chrome.runtime && chrome.runtime.sendMessage) {
        console.log('[ExtensionDetector] Tentative de communication avec l\'extension');
        try {
          chrome.runtime.sendMessage(
            EXTENSION_ID,
            { type: 'PING' },
            (response) => {
              clearTimeout(timeoutId);
              if (chrome.runtime.lastError) {
                console.log('[ExtensionDetector] Extension non installée:', chrome.runtime.lastError.message);
                setIsExtensionInstalled(false);
              } else {
                console.log('[ExtensionDetector] Extension détectée!', response);
                setIsExtensionInstalled(true);
              }
              setIsChecking(false);
            }
          );
        } catch (error) {
          console.error('[ExtensionDetector] Erreur:', error);
          clearTimeout(timeoutId);
          setIsExtensionInstalled(false);
          setIsChecking(false);
        }
      } else {
        console.log('[ExtensionDetector] Chrome API non disponible');
        clearTimeout(timeoutId);
        setIsExtensionInstalled(false);
        setIsChecking(false);
      }
    };

    checkExtension();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  // Ne rien afficher pendant la vérification ou si l'extension est installée
  if (isChecking || isExtensionInstalled) {
    return null;
  }

  // Afficher seulement si l'extension n'est pas installée
  return (
    <div className={styles.extensionDetector}>
      <div className={styles.notInstalled}>
        <svg className={styles.icon} viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
        <a 
          href={CHROME_STORE_URL} 
          target="_blank" 
          rel="noopener noreferrer"
          className={styles.link}
        >
          {t('extension.notInstalled', 'Installez l\'extension, cliquez ici')}
        </a>
      </div>
    </div>
  );
};

export default ExtensionDetector;
